import React, { useCallback, useState } from 'react';

import { useNavigate } from 'react-router';

import { useGeolocation } from 'state/geolocation';
import { useLocale } from 'state/intl';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { ServiceMode, useOrderContext } from 'state/order';
import { isMobile } from 'utils/environment';
import { routes } from 'utils/routing';

import { GeolocationModalView } from './geolocation-modal-view';

export const AutoGeolocationModal = () => {
  const {
    isPermissionPrompt,
    setPermissionChecking,
    setPermissionPrompt,
    setPermissionDenied,
    isPermissionKnown,
  } = useGeolocation();
  const { determiningLocaleComplete } = useLocale();
  const navigate = useNavigate();
  const enableAutoLocale = useFlag(LaunchDarklyFlag.ENABLE_AUTO_LOCALE);
  // This ensures that autoSelectRestaurant hook does not run prior to correct domain / locale being selected
  const autoLocaleComplete = !enableAutoLocale || determiningLocaleComplete;
  // Auto geolocation modal should only show on mobile sized devices (including mobile on web app)
  const openModalOnMount = isMobile() && isPermissionPrompt;
  const { serviceMode } = useOrderContext();

  const [modalOpen, setModalOpen] = useState(openModalOnMount);

  const reRouteAddress =
    serviceMode === ServiceMode.DELIVERY ? routes.address : routes.storeLocator;

  const handleGeolocationPrompt = useCallback(() => {
    setModalOpen(false);
    setPermissionChecking();
  }, [setPermissionChecking]);

  const handleDismissModal = useCallback(() => {
    setModalOpen(false);
    setPermissionPrompt();
  }, [setPermissionPrompt]);

  const handleSelectManually = useCallback(() => {
    navigate(reRouteAddress);
    setPermissionDenied();
  }, [navigate, reRouteAddress, setPermissionDenied]);

  const showModal = modalOpen && autoLocaleComplete && !isPermissionKnown;

  return showModal ? (
    <GeolocationModalView
      handleDismissModal={handleDismissModal}
      handleGeolocationPrompt={handleGeolocationPrompt}
      handleSelectManually={handleSelectManually}
    />
  ) : null;
};
